import * as React from "react";

function Down(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={20} height={19} fill="none" {...props}>
      <path
        d="M1.367 5.836S4.116 1.564 6.76 1.391c2.642-.173 3.421.987 3.421.987"
        stroke="#939393"
        strokeWidth={2}
      />
      <path
        d="M15.58 18.033l1.782-6.983-7.655 1.676 5.874 5.307z"
        fill="#939393"
      />
      <path
        d="M13.24 9.711l.693 2.668M12.387 6.477l.666 2.322M11.095 3.39l.867 2.18"
        stroke="#939393"
        strokeWidth={2}
      />
    </svg>
  );
}

const MemoDown = React.memo(Down);
export default MemoDown;
